"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return GlobalizedAlternates;
    }
});
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function GlobalizedAlternates({ href, currentPrefixData, defaultPrefix, pathPrefixes, alternateLanguageDefaults = [], getPrefixForPair, host, Head }) {
    const unglobalizedHref = (0, _react.useMemo)(()=>{
        return href.replace(new RegExp(`^/${currentPrefixData.prefix}`), '');
    }, [
        href,
        currentPrefixData.prefix
    ]);
    const createHrefForPair = (0, _react.useCallback)((pair)=>{
        const prefix = getPrefixForPair(pair);
        // If no prefix is found, return undefined to indicate this pair should be skipped
        if (!prefix) {
            return undefined;
        }
        const url = new URL(prefix === defaultPrefix.prefix ? unglobalizedHref : `/${prefix}${unglobalizedHref}`, host);
        return url.toString().replace(/\/$/, '');
    }, [
        unglobalizedHref,
        defaultPrefix.prefix,
        getPrefixForPair,
        host
    ]);
    return /*#__PURE__*/ _react.default.createElement(Head, null, /*#__PURE__*/ _react.default.createElement("link", {
        rel: "canonical",
        href: createHrefForPair(currentPrefixData)
    }), /*#__PURE__*/ _react.default.createElement("link", {
        key: "x-default",
        rel: "alternate",
        href: createHrefForPair(defaultPrefix),
        hrefLang: "x-default"
    }), Object.values(pathPrefixes).map((prefix)=>{
        const prefixHref = createHrefForPair(prefix);
        return prefixHref ? /*#__PURE__*/ _react.default.createElement("link", {
            key: `prefix-${prefix.prefix}`,
            rel: "alternate",
            href: prefixHref,
            hrefLang: prefix.hreflang
        }) : null;
    }), alternateLanguageDefaults.map((pair)=>{
        const defaultHref = createHrefForPair(pair);
        return defaultHref ? /*#__PURE__*/ _react.default.createElement("link", {
            key: `default-${pair.locale.iso6391}`,
            rel: "alternate",
            href: defaultHref,
            hrefLang: pair.locale.iso6391
        }) : null;
    }));
}

//# sourceMappingURL=GlobalizedAlternates.js.map